import React from 'react';
import BarCodePopupButton from "./BarCodePopupButton"
var functions = require("./functions.js");

// TextEditor component
export default class TextEditor extends React.Component {

    // manifest constants
    //const TextEditorTypeTxt="txt";
    //const TextEditorTypeCsv="csv";
    TextEditorTypeJson="json";
    TextEditorEmpty={ "cursorPosition":0,"error":""};
     // Constructor 
     constructor(props) {
        super(props);
        this.textareaRef = React.createRef();
        this.state= {
            textEditorPosition:0,
            textEditorAscii:0,
            textEditorAsciiChar:"",
            testJsonMessage:''
        };
    };
    render(){
        // hide csv buttons if not csv
        let jsonClassName="hidden";
        if(this.props.type===this.TextEditorTypeJson){
            jsonClassName="";
        }
        try {
            return(true) ? (
                <div className="hub-input">
                    <label>{this.props.label}</label>
                    <div className='align-right'>                     
                        {this.state.testJsonMessage}
                        <button onClick={this.copyToClip.bind(this)}  >Copy To Clipboard</button>&nbsp;
                        <button onClick={this.checkJsonErrorClick.bind(this)} className={jsonClassName} >Test JSON</button>&nbsp;
                        <button onClick={this.makeJsonPretty.bind(this)} className={jsonClassName} >Pretty</button>&nbsp;
                        <button onClick={this.decodeSQL.bind(this)} className={jsonClassName} >Decode SQL</button>&nbsp;
                        <button onClick={this.gotoJsonPathFinder.bind(this)} className={jsonClassName} >JSON Path Finder<img alt='JSON' height="15px" src="icons8-clone-figure-32.png"></img></button>&nbsp;
                        <button onClick={this.downLoadEditorFile.bind(this)}  >Download File</button>&nbsp;
                        <BarCodePopupButton 
                            defaultValue={this.props.defaultValue}
                            title="BarCode">
                        </BarCodePopupButton>

                        position:{this.state.textEditorPosition}
                        &nbsp;/&nbsp;
                        char:{this.state.textEditorAsciiChar}
                        &nbsp;/&nbsp;
                        ascii:{this.state.textEditorAscii}&nbsp;&nbsp;
                        Go To Position:<input className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} />
                    </div>
                    <textarea 
                        id={this.props.id}
                        name={this.props.name}
                        className={this.props.className}
                        defaultValue={this.props.defaultValue} 
                        onChange={this.onChange.bind(this)}
                        onKeyDown={this.handleKeyDownDisplayPositionInTextarea.bind(this)}
                        onClick={this.handleKeyDownDisplayPositionInTextarea.bind(this)}
                        ref={this.textareaRef}
                        >
                    </textarea>
                    <div className="hub-input-inner">
                        {this.props.children}
                    </div>
            </div>
            ) :"";
        } catch (e){
            console.log(e);
            return "";
        }
    }

    // handle key press to update cursor position
    handleKeyDownDisplayPositionInTextarea(event) {
        this.updateCharacterInfo(event.target);
    }

    updateCharacterInfo(txtArea){
        try{
            let textEditorAsciiChar=
            txtArea.value.substring(txtArea.selectionStart,txtArea.selectionStart+1);
            let textEditorAscii=textEditorAsciiChar.charCodeAt(0)
            this.setState({
                textEditorPosition : txtArea.selectionStart,
                textEditorAscii:textEditorAscii,
                textEditorAsciiChar:textEditorAsciiChar
            } );
        } catch(e){
            //window.testJsonMessage(e);
        }
    }

    // check for json errors
    checkJsonErrorClick(event){
        try{
            let jsonString=this.textareaRef.current.value;
            let res=JSON.parse(jsonString);
            console.log(JSON.stringify(res));
            this.testJsonMessage("JSON is OK")
        } catch(e){
            //alert(e);
            this.testJsonMessage(e.message);
        }   
    }

    // make json data pretty
    makeJsonPretty(event){
        try{
            let jsonString=this.textareaRef.current.value;
            let res=JSON.parse(jsonString);
            //document.getElementById(this.props.id).value=JSON.stringify(res,null,2);
            this.textareaRef.current.value=JSON.stringify(res,null,2);

        } catch(e){
            this.testJsonMessage(e.message);
        }   
    }
    // decode
    decodeSQL(event){
        try{
            let jsonString=this.textareaRef.current.value;
            jsonString=jsonString.replaceAll("\\n","\n").replaceAll(";insert",";\ninsert").replaceAll(";update",";\nupdate").replaceAll(`\\"`,`"`);
            this.textareaRef.current.value=jsonString;

        } catch(e){
            this.testJsonMessage(e.message);
        }   
    }

    // download a file
    downLoadEditorFile(){
        let string=this.textareaRef.current.value;
        let fileName=this.props.id;
        let ext=this.props.type;
        functions.downloadFile( fileName, string, ext);

    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
            let txtarea=document.getElementById(this.props.id);
            //alert(event.target.value);
            //txtarea.selectionStart=100;
            let pos=parseInt(event.target.value);
            txtarea.selectionStart=pos;
            txtarea.selectionEnd=pos+1;
            txtarea.focus();
            this.updateCharacterInfo(txtarea);
        }
    }

    gotoJsonPathFinder(event){
        functions.copyToClipBoard(this.textareaRef.current.value);
        window.open("https://jsonpathfinder.com/",'_new');
        //functions.openWindow("https://jsonpathfinder.com/");
    }
    copyToClip(event){
        functions.copyToClipBoard(this.textareaRef.current.value);
    }
    onChange(event){
        this.testJsonMessage('');
        if(this.props.onChange){
            this.props.onChange(event);
        }        
    }
    testJsonMessage(msg){
        this.setState({
            testJsonMessage:msg
        })
    }
}
